export const zIndex = {
  navBar: 1100,
  modal: 1300,
  toast: 1400,
};
